
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/snapline.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-plugins-snapline-demo-plugin-snapline"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/snapline.en.md?type=demo')
};